import { cva } from 'class-variance-authority'

export { default as Button } from './Button.vue'

export const buttonVariants = cva(
  'inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-green-500 focus-visible:ring-offset-0 disabled:pointer-events-none disabled:opacity-50 hover:opacity-70',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground hover:bg-primary/90 ',
        destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        outline: 'border border-input bg-background hover:bg-accent hover:text-accent-foreground',
        secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        link: 'text-primary underline-offset-4 hover:underline',
        primary: 'bg-[#50B83C] text-white hover:bg-[#50B83C]/90',
        custom: 'text-primary-foreground'
      },
      size: {
        default: 'h-9 py-1 px-3',
        sm: 'h-9 rounded-md px-3',
        lg: 'h-11 rounded-md px-8',
        icon: 'h-8 w-8 p-0 sm:h-9 sm:w-9',
        custom: 'min-w-[75px] h-8 py-1 px-1 sm:h-9 sm:px-2 sm:py-2'
      }
    },
    defaultVariants: {
      variant: 'custom',
      size: 'default'
    }
  }
)
